import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'

import Modal from '../../../shared/modal/Modal'
import api from '../../../utils/api'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import FormRegion from '../form/FormRegion'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import useMyPermission from '../../../hooks/useMyPermission'

function ListRegionRow({ dataArray, myPermission, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const [modalEditRegion, setModalEditRegion] = useState(false)
    const [regionData, setRegionData] = useState({})
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [regionId, setRegionId] = useState("")
    const [regionName, setRegionName] = useState("")

    const { checkPermission } = useMyPermission()
    const myPermissionEdit = checkPermission(myPermission, "region_Edit")
    const myPermissionDelete = checkPermission(myPermission, "region_Delete")

    async function updateRegion(region) {
        let msgType = 'success'
        const data = await api.patch(`region/${region._id}`, region, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            setModalEditRegion(false)
            handleOnSuccess()
        }
    }

    async function deleteRegion(id) {
        let msgType = 'success'
        const data = await api.delete(`/region/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            handleOnSuccess()
            setModalDeleteItem(false)
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
    }

    return (
        <div>
            {dataArray && dataArray.map((item) => (
                <div key={item._id} className="pg-item">
                    <div className="pg-item-main">
                        <span className="pg-item-name">{item.regionName}</span>
                    </div>

                    <div className='shd-row-box-item-action'>
                        {myPermissionEdit &&
                            <FaPencilAlt
                                className='shd-icon-row-edit'
                                title='Editar'
                                onClick={() => { setRegionData(item); setModalEditRegion(true) }}
                            />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt
                                className='shd-icon-row-trash'
                                title='Apagar'
                                onClick={() => { setModalDeleteItem(true); setRegionId(item._id); setRegionName(item.regionName) }}
                            />
                        }
                    </div>
                </div>
            ))}

            <Modal
                modalStatus={modalEditRegion}
                changeStatus={setModalEditRegion}
                w={36}
                h={30}
                content={
                    <FormRegion
                        title="Editar Região"
                        data={regionData}
                        handleSubmit={updateRegion}
                        btCancelAction={() => setModalEditRegion(false)}
                        btnText="Salvar"
                    />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteRegion(regionId)}
                message="Deseja realmente excluir essa região?"
                itemName={regionName}
            />
        </div>
    )
}

export default ListRegionRow
